import {
  faSliders,
  faHouseTree,
  faChartColumn,
  faMoneyCheckPen,
  faRightToBracket,
  faClipboardQuestion,
  faClipboardListCheck,
  faEnvelopeCircleCheck,
} from '@fortawesome/pro-light-svg-icons';

import { faGripLines } from '@fortawesome/pro-thin-svg-icons';

import {
  faPlus,
  faBolt,
  faPeanuts,
  faBowlRice,
  faDrumstick,
} from '@fortawesome/sharp-solid-svg-icons';

import {
  faCheck,
  faCartShopping,
  faMagnifyingGlass,
  faXmark as faXmarkSolid,
  faBars,
  faArrowRotateRight,
  faFilePdf,
} from '@fortawesome/free-solid-svg-icons';
import {
  faGoogle,
  faTwitter,
  faFacebookF,
  faInstagram,
  faWhatsappSquare,
} from '@fortawesome/free-brands-svg-icons';

import {
  faUser,
  faShirt,
  faRoute,
  faStore,
  faPotFood,
  faDumbbell,
  faArrowLeft,
  faCroissant,
  faListCheck,
  faTelescope,
  faRotateBack,
  faArrowRight,
  faPaintBrush,
  faHeartPulse,
  faCircleNotch,
  faSpinnerThird,
  faPersonDollyEmpty,
  faMailboxOpenLetter,
  faMessageExclamation,
  faCommentsQuestionCheck,
  faTrashCan,
} from '@fortawesome/pro-solid-svg-icons';

import { faToggleOn } from '@fortawesome/sharp-solid-svg-icons';

export const FontAwesomeicons = [
  faBolt,
  faPlus,
  faUser,
  faCartShopping,
  faBars,
  faStore,
  faCheck,
  faShirt,
  faRoute,
  faGoogle,
  faPeanuts,
  faPotFood,
  faSliders,
  faTwitter,
  faToggleOn,
  faArrowRotateRight,
  faFilePdf,
  faDumbbell,
  faBowlRice,
  faListCheck,
  faGripLines,
  faDrumstick,
  faTelescope,
  faFacebookF,
  faHouseTree,
  faCroissant,
  faInstagram,
  faArrowLeft,
  faPaintBrush,
  faArrowRight,
  faXmarkSolid,
  faRotateBack,
  faHeartPulse,
  faChartColumn,
  faCircleNotch,
  faSpinnerThird,
  faMoneyCheckPen,
  faRightToBracket,
  faWhatsappSquare,
  faMagnifyingGlass,
  faPersonDollyEmpty,
  faClipboardQuestion,
  faMailboxOpenLetter,
  faMessageExclamation,
  faTrashCan,
  faClipboardListCheck,
  faEnvelopeCircleCheck,
  faCommentsQuestionCheck,
];
